<template>
  <SharedApiDataSourceList
    :value="value"
    @input="$emit('input', $event)"
    :data-sources="dataSources"
    :loading="loading"
    :api-service="apiService"
    @create="$emit('create')"
    @edit="$emit('edit', $event)"
    @view-history="$emit('view-history', $event)"
    @refresh="fetchSources"
  />
</template>

<script>
import { mapGetters } from 'vuex';
import { SharedApiDataSourceList } from '@/features/Share/components/apiDataSource';
import apiDataSourceService from '../../services/apiDataSourceService';

export default {
  name: 'ApiDataSourceList',
  components: { SharedApiDataSourceList },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    registerId: {
      type: String,
      default: null,
    },
  },
  computed: {
    ...mapGetters('REGISTERS', {
      dataSources: 'GET_API_DATA_SOURCES',
      loading: 'GET_API_DATA_SOURCE_LOADING',
    }),
    apiService() {
      return {
        triggerPull: (id) => apiDataSourceService.triggerManualPull(id),
        toggleSchedule: (id, enabled) => apiDataSourceService.toggleSchedule(id, enabled),
        deleteDataSource: (id) => this.$store.dispatch('REGISTERS/DELETE_API_DATA_SOURCE', id),
      };
    },
  },
  watch: {
    value(open) {
      if (open && this.registerId) {
        this.fetchSources();
      }
    },
  },
  methods: {
    fetchSources() {
      this.$store.dispatch('REGISTERS/FETCH_API_DATA_SOURCES', {
        registerId: this.registerId,
      });
    },
  },
};
</script>
